/**
 * laguna-weekly-flash.js — Laguna Store — v2.0
 * Countdown para o Weekly Flash.
 * Lê o timestamp alvo do data-end passado pelo Liquid (UTC).
 * Se data-end = 0, conta até a próxima segunda às 12h BRT.
 */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function nextMondayNoonBRT() {
    const now = new Date();
    // BRT = UTC-3
    const brtOffset = -3 * 60; // minutos
    const brtNow = new Date(now.getTime() + (brtOffset - now.getTimezoneOffset()) * 60000);

    const day = brtNow.getDay(); // 0=dom, 1=seg
    const hour = brtNow.getHours();

    // Se hoje é segunda e ainda não passou das 12h BRT → target é hoje às 12h BRT
    let daysUntilMonday;
    if (day === 1 && hour < 12) {
      daysUntilMonday = 0;
    } else {
      daysUntilMonday = (8 - day) % 7 || 7;
    }

    const target = new Date(brtNow);
    target.setDate(brtNow.getDate() + daysUntilMonday);
    target.setHours(12, 0, 0, 0);

    // Converte de volta para UTC
    return new Date(target.getTime() - (brtOffset - now.getTimezoneOffset()) * 60000);
  }

  function initCountdown(section) {
    const endAttr = section.dataset.end;
    const endTs   = endAttr ? parseInt(endAttr, 10) : 0;

    const daysEl    = section.querySelector('[data-cd-days]');
    const hoursEl   = section.querySelector('[data-cd-hours]');
    const minutesEl = section.querySelector('[data-cd-minutes]');
    const secondsEl = section.querySelector('[data-cd-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    // Target: timestamp do Liquid (segundos) ou próxima segunda
    const targetDate = (endTs > 0)
      ? new Date(endTs * 1000)
      : nextMondayNoonBRT();

    function tick() {
      const diff = targetDate - Date.now();

      if (diff <= 0) {
        // Semana trocou — recarrega para exibir nova semana
        location.reload();
        return;
      }

      const totalSec = Math.floor(diff / 1000);
      const d = Math.floor(totalSec / 86400);
      const h = Math.floor((totalSec % 86400) / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;

      daysEl.textContent    = pad(d);
      hoursEl.textContent   = pad(h);
      minutesEl.textContent = pad(m);
      secondsEl.textContent = pad(s);
    }

    tick();
    const timer = setInterval(tick, 1000);

    // Cleanup quando a section sair do DOM (ex: Theme Editor)
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (!e.isIntersecting) clearInterval(timer); });
      });
      io.observe(section);
    }
  }

  function init() {
    document.querySelectorAll('[data-weekly-flash]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();